// extracted by mini-css-extract-plugin
export var collapsedSummary = "_if-0";